import request from '@/common/request'

class PerfilService {
  getAll() {
    return request.get('/perfis')
  }

  create(data) {
    return request.post('/perfis', data)
  }

  update(id, data) {
    return request.patch(`/perfis/${id}`, data)
  }

  deleteById(id) {
    return request.delete(`/perfis/${id}`)
  }

  getPermissoesByPerfil(id) {
    return request.get(`/perfis/${id}/permissoes`)
  }

  addPermissaoRelationship(perfilId, permissaoId) {
    return request.put(`/perfis/${perfilId}/permissoes/${permissaoId}`)
  }

  removePermissaoRelationship(perfilId, permissaoId) {
    return request.delete(`/perfis/${perfilId}/permissoes/${permissaoId}`)
  }
}

export default new PerfilService()
